import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
} from 'react'
import { type ProductOffer } from '@/pages/api/[account]/search/offers/ProductOffer'

type ProductOffersContext = {
  isLoadingOffers?: boolean
  productOffers?: ProductOffer[]
}

const initialValues = {
  isLoadingOffers: false,
  productOffers: [],
}

const ProductOffersContext = createContext<ProductOffersContext | undefined>(
  undefined
)

export const ProductOffersProvider = ({
  children,
  isLoadingOffers = initialValues.isLoadingOffers,
  productOffers = initialValues.productOffers,
}: PropsWithChildren<ProductOffersContext>) => {
  const value = useMemo(
    () => ({ isLoadingOffers, productOffers }),
    [isLoadingOffers, productOffers]
  )

  return (
    <ProductOffersContext.Provider value={value}>
      {children}
    </ProductOffersContext.Provider>
  )
}

export const useProductOffersContext = () => {
  const context = useContext(ProductOffersContext)

  if (context === undefined) {
    throw new Error(
      'useProductOffersContext must be used within a ProductOffersProvider'
    )
  }

  return context
}
